import React, { useState, useEffect } from 'react';
import BegoNuFernandez from "../img/ilustracion-transparente (1).png";
import { ArrowIcon } from "./ArrowIcon";
import i18next from 'i18next';

export const About = () => {
    return (
        <>
            <div className="page-content text-center d-flex align-items-center flex-column text-white">
                <div className="section-title" id="smallscreen">
                    <h1 className="wid">
                        {i18next.t('name')}
                        <p className="subtitle">{i18next.t('occupation')}</p>
                    </h1>

                </div>
                    {window.innerWidth <= 1024 ? 
                        <>
                            <div className="section-content" id="aboutContent">
                                <SmallTypewriter
                                    texts={[
                                        i18next.t('text1'),
                                        i18next.t('text2'),
                                        i18next.t('text3'),
                                    ]}
                                />
                            </div>
                        </>
                    :
                        <>
                            <div className="section-content" id="aboutContent">
                                <div className="col-5 position-absolute bottom-0 start-0">
                                    <img src={BegoNuFernandez} className="about-img p-0 m-0" alt="Bego Nuñez Fernandez"/>
                                </div>
                                <TypewriterText
                                    texts={[
                                        i18next.t('text1'),
                                        i18next.t('text2'),
                                        i18next.t('text3'),
                                    ]}
                                />                                                
                            </div>
                        </>
                    }
            </div>
        </>
    );
};

const TypewriterText = ({ texts }) => {
    const [historyTexts, setHistoryTexts] = useState([]);
    const [actualText, setActualText] = useState('');
    const [index, setIndex] = useState(0);
    const [buttonClicked, setButtonClicked] = useState(false);

    useEffect(() => {
        if (index < texts.length) {
            let text = texts[index];
            let textDisplayed = '';
            let i = 0;

            const interval = setInterval(() => {
                textDisplayed += text.charAt(i);
                setActualText(textDisplayed);
                i++;

                if (i === text.length) {
                    clearInterval(interval);
                }
            }, 50);

            return () => clearInterval(interval);
        }
    }, [texts, index]);

    const handleButtonClick = () => {
        if (index < texts.length) {
            setHistoryTexts(prevHistory => [...prevHistory, actualText]);
            setIndex(prevIndex => prevIndex + 1);
            setActualText('');
            setButtonClicked(true);
        }
    };

    return (
        <div className="about-description position-absolute end-0">
            {historyTexts.map((text, index) => (
                <p key={index} className="pe-4 about-text">{text}</p>
            ))}
            <div className="d-flex align-items-center">
                <p className="pe-4 about-text">{actualText}</p>
                {index < texts.length - 1 && (
                    <div onClick={handleButtonClick} className="pointer position-relative">
                        <ArrowIcon />
                        {buttonClicked ? null : (
                            <p className="press-here">
                                {i18next.t('clickHere')}
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TypewriterText;


const SmallTypewriter = ({ texts }) => {
    const [historyTexts, setHistoryTexts] = useState([]);
    const [actualText, setActualText] = useState('');
    const [index, setIndex] = useState(0);
    const [buttonClicked, setButtonClicked] = useState(false);
  
    useEffect(() => {
        if (index < texts.length) {
            let text = texts[index];
            let textDisplayed = '';
            let i = 0;
    
            const interval = setInterval(() => {
                textDisplayed += text.charAt(i);
                setActualText(textDisplayed);
                i++;
        
                if (i === text.length) {
                    clearInterval(interval);
                }
            }, 50);
    
            return () => clearInterval(interval);
        }
    }, [texts, index]);
  
    const handleButtonClick = () => {
        if (index < texts.length) {
            setHistoryTexts(prevHistory => [...prevHistory, actualText]);
            setIndex(prevIndex => prevIndex + 1);
            setActualText('');
            setButtonClicked(true);
        }
    };
  
    return (
        <div className="about-description no-cut pt-3">
            {historyTexts.map((text, index) => (
                <p key={index} className="about-text pb-2 px-1">{text}</p>
            ))}
            <div className="d-flex w-100 dialog-space">
                <div className="col-5 position-relative bottom-0 start-0">
                    <img src={BegoNuFernandez} className="about-img position-absolute bottom-0 p-0 m-0" alt="Bego Nuñez Fernandez"/>
                </div>
                <p className="about-text dialog pe-1">
                    {actualText}
                    {index < texts.length - 1 && (
                        <div onClick={handleButtonClick} className="pointer position-relative ms-5">
                            <ArrowIcon />
                            {!buttonClicked && (
                                <p className="press-here">
                                    {i18next.t('clickHere')}
                                </p>
                            )}
                        </div>
                    )}
                </p>
            </div>
        </div>
    );
};